export const GET_ID_DOCUMENTLIST = '[ID_VALIDATOR][GET] Get Document Id';
export const GET_SERVICE_TYPES = '[SERVICE_TYPES][GET] Get Service Type List';
export const SET_SELECTED_ID_DOC = '[SET][SELECTED_ID_DOC] Set Select ID doc';

export const ID_DOC_UPLOAD_PENDING = '[ID_DOC_UPLOAD][PENDING] IdDoc upload pending';
export const ID_DOC_UPLOAD_FAILURE = '[ID_DOC_UPLOAD][FAILURE] PROFORMA upload failure';
export const SET_VALIDATE_RESPONSE = '[SET][VALIDATE][RESPONSE] set validate response';
export const RESET_ID_DOC_UPLOAD = '[ID_DOC_UPLOAD][RESET] reset Id doc upload ';
export const RESET_IDVALIDATOR_STATE = '[RESET][IDVALIDATOR][STATE] reset ID Validator state';
export const SET_SELECTEDTYPE_STATE = '[SET][SELECTEDTYPE] Set ServiceType doc';

export const RESET_POLLINGQUEUE_STATE = '[RESET][POLLINGQUEUE][STATE] reset polling queue state';
export const SET_SWITCH_TO_VIEW = '[SET][SWITCH][TO][VIEW] set switch to view';
export const SET_POLLING_QUEUE_PAYLOAD = '[SET][POLLING][QUEUE][PAYLOAD] set polling queue payload';
export const SET_POLLING_QUEUE_RESPONSE = '[SET][POLLING][QUEUE][RESPONSE] set polling queue response';
export const SET_POLLING_DETAIL_RESPONSE = '[SET][POLLING][DETAIL][RESPONSE] set polling detail response';
export const SET_MANUAL_REQUEST_RESULT = '[SET][MANUAL][REQUEST][RESULT] set manual request result';

export const ENABLE_SERVICE_SPINNER = '[ENABLE][SERVICE_SPINNER] enable disable service spinner';

export const DELETE_UPLOAD_FILE= '[DELETE] [UPLOAD] [FILE] delete uploaded file';
export const RESET_UPLOAD_FILE= '[RESET] [UPLOAD] [FILE] reset uploaded file';